import styled from "styled-components";
import { DatePicker } from "antd";
import { theme } from "../../../config";

export const DatePickerStyled = styled(DatePicker)`
  ${theme.defaultInputStyle}
  width: ${(props: any) => props.width || "100%"};
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 30px;
  }

  &.ant-picker:hover {
    border: 1px solid ${theme.colors.secondary};
  }

  .ant-picker-input > input {
    color: #111111;
    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 12.6px;
      line-height: 16px;
    }
  }
  &.ant-picker.ant-picker-disabled {
    border: 1px solid ${theme.colors.borderColor};
    background-color: ${theme.colors.neutral.black7};
  }
  &.ant-picker.ant-picker-disabled:hover {
    border: 1px solid #AAAAAA
  }
  .ant-picker-input > input[disabled] {
    color: ${theme.colors.neutral.black3};
  }
  .ant-picker-input {
    .ant-picker-suffix {
      color: rgb(38, 38, 38);
    }
  }
`;
